// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/img/chat_bg-2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatModal_orderModal__pId3A {
  padding: 0;
}
.ChatModal_orderModal__pId3A .modal__inner {
  height: 100%;
  border-radius: 0;
  max-width: none;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.ChatModal_orderModal__pId3A .modal__inner .modal__header {
  padding: 24px 16px;
  border: none;
}
.ChatModal_orderModal__pId3A .modal__inner .modal__body {
  background: #FFF;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 0;
}
.ChatModal_orderModal__pId3A .modal__inner .modal__body .submitBlock {
  margin-top: auto;
}
.ChatModal_orderModal__pId3A .options-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
@media (max-width: 1200px) {
  .ChatModal_orderModal__pId3A .options-list {
    gap: 24px;
  }
}
.ChatModal_orderModal__pId3A .checkbox-row p, .ChatModal_orderModal__pId3A .radio-row p {
  line-height: 114%;
  border: none;
}
.ChatModal_orderModal__pId3A .ChatModal_modal-text__jyvbF {
  font-size: 14px;
  line-height: 20px;
  color: #54575C;
}
.ChatModal_orderModal__swipeHandler__8LsJK {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.ChatModal_orderModal__swipeHandler__8LsJK span {
  border-radius: 8px;
  background: #FFF;
  width: 88px;
  height: 2px;
  z-index: 2;
  display: block;
  position: relative;
}
.ChatModal_orderModal__swipeHandler__8LsJK::before {
  content: "";
  position: absolute;
  bottom: -5vh;
  left: 0;
  right: 0;
  width: 100%;
  height: 30vh;
  background: transparent;
}
.ChatModal_orderModal__top__ta3Dh {
  width: 100%;
  min-height: 216px;
  height: 55vw;
  max-height: 420px;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
}
.ChatModal_orderModal__top__ta3Dh .swiper {
  height: 100%;
}
.ChatModal_orderModal__top__ta3Dh .swiper-pagination-bullet {
  width: 6px;
  height: 6px;
  margin: 0 6px;
  background: #D9D9D9;
  opacity: 0.4;
}
.ChatModal_orderModal__top__ta3Dh .swiper-pagination-bullet-active {
  background: #FAFAFA;
  opacity: 1;
}
.ChatModal_orderModal__top__ta3Dh .swiper-slide {
  width: 100%;
}
.ChatModal_orderModal__top__ta3Dh .swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.ChatModal_orderModal__roundedTop__FrR8- {
  border-radius: 16px 16px 0 0;
}
.ChatModal_orderModal__body__dSj-c {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 16px 16px 0 0;
  padding: 0 16px;
}
.ChatModal_orderModal__body_load__Hh4aO {
  gap: initial;
}
.ChatModal_orderModal__block__1DxAu {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 5px;
}
@media (min-width: 1200px) {
  .ChatModal_orderModal__block__1DxAu {
    margin-bottom: 24px;
  }
}
.ChatModal_orderModal__blockTitle__hSmnK {
  font-size: 16px;
  font-weight: 500;
  line-height: 114%;
  padding-bottom: 4px;
}
@media (min-width: 640px) {
  .ChatModal_orderModal__blockTitle__hSmnK {
    font-size: 22px;
  }
}
@media (min-width: 1200px) {
  .ChatModal_orderModal__blockTitle__hSmnK {
    font-size: var(--fz-lg);
    line-height: var(--lh-lg);
  }
}
.ChatModal_orderModal__blockTitle__hSmnK::first-letter {
  text-transform: capitalize;
}
.ChatModal_orderModal__blockRequired__cgpUt {
  color: #f2200d;
}
.ChatModal_orderModal__submitBlock__ko3z- {
  padding: 16px;
  bottom: 0;
  left: 50%;
  background: #FFF;
  z-index: 2;
  position: sticky;
  width: 100%;
}
.ChatModal_orderModal__submitBlockHead__uksyZ {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ChatModal_orderModal__submitBlockHead__uksyZ h5 {
  color: #151B26;
  line-height: 114%;
  font-size: 14px;
  font-weight: 600;
}
.ChatModal_orderModal__submitBlockHead__uksyZ p {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 114%;
  letter-spacing: -0.24px;
}
.ChatModal_orderModal__submitBlockBottom__qIdme {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}
.ChatModal_orderModal__calc__3mUFl {
  height: 44px;
  width: 88px;
  min-width: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #EEE;
  margin-right: 12px;
}
.ChatModal_orderModal__calcPlus__Dsh-s, .ChatModal_orderModal__calcMinus__0SVej {
  width: 16px;
  height: 20px;
  display: flex;
  align-items: center;
}
.ChatModal_orderModal__calcPlus__Dsh-s:disabled, .ChatModal_orderModal__calcMinus__0SVej:disabled {
  opacity: 0.5;
}
.ChatModal_orderModal__calcNum__uL3S0 {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: #000;
  width: 32px;
  margin: 0 4px;
  text-align: center;
}
.ChatModal_orderModal__picker__4DNTj {
  width: 100%;
  position: relative;
}
.ChatModal_orderModal__picker__4DNTj img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  pointer-events: none;
}
@media (min-width: 640px) {
  .ChatModal_orderModal__picker__4DNTj img {
    right: 20px;
    width: 32px;
    height: 32px;
  }
}
@media (min-width: 1200px) {
  .ChatModal_orderModal__picker__4DNTj img {
    width: 22px;
    height: 22px;
    right: 10px;
  }
}
.ChatModal_orderModal__picker__4DNTj input[type=date]:not(.ChatModal_has_value__PXqo6)::-webkit-datetime-edit-fields-wrapper,
.ChatModal_orderModal__picker__4DNTj input[type=datetime-local]:not(.ChatModal_has_value__PXqo6)::-webkit-datetime-edit-fields-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  -webkit-appearance: none;
}
.ChatModal_orderModal__picker__4DNTj input[type=date]::-webkit-inner-spin-button,
.ChatModal_orderModal__picker__4DNTj input[type=datetime-local]::-webkit-inner-spin-button,
.ChatModal_orderModal__picker__4DNTj input[type=date]::-webkit-calendar-picker-indicator,
.ChatModal_orderModal__picker__4DNTj input[type=datetime-local]::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  -webkit-appearance: none;
}
.ChatModal_orderModal__picker__4DNTj input[type=date], .ChatModal_orderModal__picker__4DNTj input[type=datetime-local] {
  -webkit-appearance: none;
  width: -webkit-fill-available;
}
.ChatModal_orderModal__picker__4DNTj input[type=date]:not(.ChatModal_has_value__PXqo6):before,
.ChatModal_orderModal__picker__4DNTj input[type=datetime-local]:not(.ChatModal_has_value__PXqo6):before {
  content: attr(placeholder);
  color: #BEC0C2;
  width: 100%;
}
.ChatModal_orderModal__picker__4DNTj input[type=date]::after,
.ChatModal_orderModal__picker__4DNTj input[type=datetime-local]::after {
  position: absolute;
  right: 0;
  content: "";
  width: 20px;
  height: 100%;
  background: white;
  border-radius: 8px;
}
.ChatModal_orderModal__picker__4DNTj input {
  width: 100%;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #E8ECEE;
  background: #FFF;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  padding: 3px 10px;
  position: relative;
}
@media (min-width: 640px) {
  .ChatModal_orderModal__picker__4DNTj input {
    height: 64px;
    padding-left: 32px;
    font-size: 20px;
  }
}
@media (min-width: 1200px) {
  .ChatModal_orderModal__picker__4DNTj input {
    height: 38px;
    padding-left: 10px;
    font-size: var(--fz-md);
    line-height: normal;
  }
}
.ChatModal_orderModal__picker__4DNTj input::placeholder {
  color: #BEC0C2;
}
.ChatModal_orderModal__picker__4DNTj .react-datepicker-wrapper {
  width: 100%;
}
.ChatModal_orderModal__sk1__b74va, .ChatModal_orderModal__sk2__4\\+6IS, .ChatModal_orderModal__sk3__uf1RO, .ChatModal_orderModal__sk4__9pkrI {
  border-radius: 2px;
  height: 13px;
  width: 100%;
  margin-top: 8px;
}
.ChatModal_orderModal__sk2__4\\+6IS {
  width: 85%;
  margin-top: 10px;
}
.ChatModal_orderModal__sk3__uf1RO {
  width: 50%;
  margin-top: 10px;
}
.ChatModal_orderModal__sk4__9pkrI {
  width: 20%;
  margin-top: 16px;
  margin-bottom: 9px;
}
.ChatModal_orderModal__sk5__xCgCH {
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 4px;
  padding-top: 4px;
  padding-bottom: 12px;
  border-bottom: 1px solid #F3F2F2;
}
.ChatModal_orderModal__sk5__xCgCH span {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: block;
  margin-top: 4px;
  margin-bottom: 4px;
}
.ChatModal_orderModal__sk5__xCgCH div {
  border-radius: 2px;
  height: 14px;
  width: calc(100% - 34px);
}
.ChatModal_orderModal__info__8awKR {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ChatModal_orderModal__infoTitle__4VJup {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 144%;
  color: var(--text-color);
}
.ChatModal_orderModal__infoText__wW1r4 {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 144%;
  word-wrap: break-word;
}
.ChatModal_orderModal__infoText__wW1r4 a {
  color: var(--accent-color);
  text-decoration: underline;
}
.ChatModal_orderModal__infoText__wW1r4 ul, .ChatModal_orderModal__infoText__wW1r4 ol {
  margin: 0;
  padding: 0;
  padding-left: 16px;
}
.ChatModal_orderModal__infoText__wW1r4 img {
  max-width: 100%;
}
.ChatModal_orderModal__infoText__wW1r4 table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  margin: 0;
  overflow: hidden;
}
.ChatModal_orderModal__infoText__wW1r4 table td, .ChatModal_orderModal__infoText__wW1r4 table th {
  min-width: 1em;
  border: 2px solid #ced4da;
  padding: 3px 5px;
  vertical-align: top;
  box-sizing: border-box;
  position: relative;
}
.ChatModal_orderModal__infoText__wW1r4 table td > *, .ChatModal_orderModal__infoText__wW1r4 table th > * {
  margin-bottom: 0;
}
.ChatModal_orderModal__infoText__wW1r4 table th {
  font-weight: 700;
  text-align: left;
  background-color: #f1f3f5;
}
.ChatModal_orderModal__infoText__wW1r4 p {
  min-height: 20px;
}
.ChatModal_orderModal__infoText__wW1r4 h1, .ChatModal_orderModal__infoText__wW1r4 h2, .ChatModal_orderModal__infoText__wW1r4 h3 {
  color: #303030;
}
.ChatModal_orderModal__infoText__wW1r4 pre {
  background: #2b2a2a;
  color: #fff;
  padding: 8px;
  display: flex;
  border-radius: 8px;
  width: 100%;
  white-space: pre-wrap;
}
.ChatModal_orderModal__infoText__wW1r4 code {
  width: 100%;
  display: block;
  color: #fff;
  background-color: #f1f3f5;
}
.ChatModal_orderModal__files__kV2-u {
  padding-top: 8px;
}
.ChatModal_orderModal__files__kV2-u .orderModal__file {
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 8px 32px 8px 4px;
  border-radius: 12px;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  transition: var(--transition);
  margin-bottom: 8px;
}
.ChatModal_orderModal__files__kV2-u .orderModal__file img {
  width: 15px;
  height: 21px;
}
.ChatModal_orderModal__file__F4sSo {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 2px;
  margin-bottom: 8px;
  padding: 8px 32px 8px 4px;
  background: var(--white);
  border-radius: 12px;
  border: 1px solid transparent;
  position: relative;
  transition: var(--transition);
}
@media (hover: hover) {
  .ChatModal_orderModal__file__F4sSo:hover {
    border-color: var(--accent-color);
  }
}
.ChatModal_orderModal__fileContent__Rch1r {
  display: flex;
  align-items: center;
  gap: 8px;
  transition: var(--transition);
}
.ChatModal_orderModal__fileContent__Rch1r img {
  max-width: 24px;
  min-width: 24px;
}
.ChatModal_orderModal__fileIsLoading__loader__xlhBq {
  height: 3px;
  background: #4084F8;
}
.ChatModal_orderModal__fileName__Jxq3t {
  font-size: var(--fz-md);
  line-height: var(--lh-md);
}
.ChatModal_orderModal__fileSize__nYr3i {
  font-size: var(--fz-sm);
  line-height: 1;
  color: #7A808B;
  margin-top: 2px;
}
.ChatModal_orderModal__fileDelete__mmMLM {
  margin-left: auto;
  color: var(--error);
}
.ChatModal_orderModal__object__yuVLY {
  border-radius: 12px;
  background: #FAFAFA;
  padding: 8px;
  display: flex;
  align-items: center;
}
.ChatModal_orderModal__objectIco__rlFMb {
  width: 26px;
  min-width: 26px;
  height: 26px;
  margin-right: 8px;
}
.ChatModal_orderModal__objectText__ti14o span {
  font-size: 14px;
  line-height: 114%;
  color: #7A808B;
}
.ChatModal_orderModal__objectText__ti14o p {
  font-size: 16px;
  color: #101618;
  line-height: 23.04px;
}
.ChatModal_orderModal__objectArrow__tIZXL {
  margin-left: auto;
}
@media (min-width: 640px) {
  .ChatModal_orderModal__top__ta3Dh .swiper-pagination {
    bottom: 24px;
  }
  .ChatModal_orderModal__top__ta3Dh .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    margin: 0 12px;
    background: #D9D9D9;
    opacity: 0.4;
  }
  .ChatModal_orderModal__top__ta3Dh .swiper-pagination-bullet-active {
    background: #FAFAFA;
    opacity: 1;
  }
  .ChatModal_orderModal__body__dSj-c {
    padding: 16px 24px 0;
  }
  .ChatModal_orderModal__submitBlock__ko3z- {
    padding: 24px;
    margin-left: -24px;
  }
  .ChatModal_orderModal__submitBlockHead__uksyZ h5 {
    font-size: 32px;
  }
  .ChatModal_orderModal__submitBlockHead__uksyZ p {
    font-size: 28px;
    letter-spacing: -0.56px;
  }
  .ChatModal_orderModal__submitBlockBottom__qIdme {
    margin-top: 18px;
  }
  .ChatModal_orderModal__calc__3mUFl {
    border-radius: 16px;
    width: 195px;
    min-width: 195px;
    height: 76px;
    margin-right: 16px;
  }
  .ChatModal_orderModal__calcNum__uL3S0 {
    width: 59px;
    height: 22px;
    margin: 0 16px;
    font-size: 28px;
  }
  .ChatModal_orderModal__calcPlus__Dsh-s, .ChatModal_orderModal__calcMinus__0SVej {
    width: 32px;
    height: 32px;
  }
  .ChatModal_orderModal__calcPlus__Dsh-s svg, .ChatModal_orderModal__calcMinus__0SVej svg {
    width: 32px;
    height: 32px;
  }
}
.ChatModal_orderModal__inputError__lwhbf.ChatModal_orderModal__inputError__lwhbf {
  border-color: #F2200D;
}
.ChatModal_orderModal__time__D18jW {
  font-size: 12px;
  padding: 2px 4px;
  min-height: auto;
}

.ChatModal_photoBlock__UIMQi {
  display: grid;
  grid-gap: 8px;
  grid-template-columns: repeat(3, 1fr);
  position: relative;
}
@media (min-width: 1200px) {
  .ChatModal_photoBlock__UIMQi {
    grid-template-columns: repeat(6, 1fr);
  }
}
.ChatModal_photoBlock__append__X0dn4 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  height: 105px;
  cursor: pointer;
  background: rgba(var(--accent-color-rgb), 0.1);
}
.ChatModal_photoBlock__append__X0dn4.ChatModal_error__9L5Cw {
  border: 1px solid #F2200D;
}
.ChatModal_photoBlock__plus__Ngv43 {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--accent-color);
  color: var(--accent-text-color);
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ChatModal_photoBlock__preview__Mp8hP {
  height: 105px;
  border-radius: 8px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.ChatModal_photoBlock__preview__Mp8hP > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.ChatModal_photoBlock__close__thpvX {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  background: #E97676;
}
@media (min-width: 640px) {
  .ChatModal_photoBlock__append__X0dn4, .ChatModal_photoBlock__preview__Mp8hP {
    height: 140px;
  }
}
@media (min-width: 1200px) {
  .ChatModal_photoBlock__append__X0dn4, .ChatModal_photoBlock__preview__Mp8hP {
    height: 104px;
  }
}
.ChatModal_photoBlock__camera__LmdLE {
  color: rgba(var(--accent-color-rgb), 0.45);
}
.ChatModal_photoBlock__error__Ab6kz {
  position: initial !important;
  justify-content: flex-start !important;
}
.ChatModal_photoBlock__loader__dVtik {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ChatModal_photoBlock__loader__precent__vx4PK {
  color: white;
  font-weight: 600;
  font-size: 12px;
  z-index: 1;
}
.ChatModal_photoBlock__loader__overlay__ubJnN {
  position: absolute;
  background: rgba(178, 178, 178, 0.6784313725);
  width: 100%;
  height: 100%;
  top: 0;
}
.ChatModal_photoBlock__compressBlock__rsFAh {
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 60px;
  height: 60px;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
}
.ChatModal_photoBlock__compressBlock__rsFAh svg {
  width: 24px;
  fill: none;
  animation-name: ChatModal_grow__t26Uv;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
.ChatModal_photoBlock__compressBlock__rsFAh svg path {
  stroke: white;
}
.ChatModal_photoBlock__compressLoading__jg6fF {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 3;
}
.ChatModal_photoBlock__compressLoading__jg6fF svg {
  width: 24px;
  fill: none;
  animation-name: ChatModal_grow__t26Uv;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
.ChatModal_photoBlock__compressLoading__jg6fF svg path {
  stroke: black;
}

@keyframes ChatModal_grow__t26Uv {
  0% {
    scale: 1;
  }
  50% {
    scale: 2;
  }
  100% {
    scale: 1;
  }
}
@media (min-width: 1200px) {
  label.ChatModal_checkboxAlone__EtFUE {
    flex-direction: row-reverse;
    justify-content: flex-end;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  label.ChatModal_checkboxAlone__EtFUE p {
    width: auto;
    font-weight: 500;
    font-size: var(--fz-lg);
    line-height: var(--lh-lg);
    padding-top: 5px;
    margin-right: 8px;
  }
}

@media (min-width: 1200px) {
  .ChatModal_orderModal__block__1DxAu .ChatModal_checkboxAlone__EtFUE p:last-child {
    margin-left: 0;
  }
}

.ChatModal_conditionList__xJ4u0 {
  position: initial;
  overflow: hidden;
  transition: 0.15s;
}

.ChatModal_conditionList__container__\\+EAkr {
  display: flex;
  flex-direction: column;
}
@media (max-width: 1200px) {
  .ChatModal_conditionList__container__\\+EAkr {
    gap: 24px;
  }
}

.ChatModal_qrWrapBlock__kyfe- {
  position: relative;
}
.ChatModal_qrWrapBlock__kyfe- .ChatModal_qrWrapBlock__error__ljW9I {
  position: relative;
  justify-content: flex-start;
  margin: 0;
}
@media (min-width: 1200px) {
  .ChatModal_qrWrapBlock__kyfe- .ChatModal_qrWrapBlock__error__ljW9I {
    position: absolute;
    top: 100%;
    left: 0;
    justify-content: flex-start;
    margin: 0;
  }
}

.ChatModal_qrBlock__gZAcm {
  padding: 10px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #EAF7EF;
  width: max-content;
  cursor: pointer;
}
.ChatModal_qrBlock--error__Bwfjz {
  color: var(--red);
}
.ChatModal_qrBlock__gZAcm svg {
  width: 13px;
  height: 13px;
}
.ChatModal_qrBlock__gZAcm svg path {
  fill: #2DBE64;
}

.ChatModal_QRInput__yA8iF {
  position: relative;
}
.ChatModal_QRInput__yA8iF input:disabled {
  background: none;
}
.ChatModal_QRInput__icon__823hK {
  position: absolute;
  top: calc(50% - 16px);
  right: 10px;
  background: none;
}

.ChatModal_chatModal__MCV4E {
  display: flex;
  flex-direction: column;
  height: 100%;
}
@media (min-width: 1200px) {
  .ChatModal_chatModal__MCV4E {
    min-height: 592px;
    height: auto;
    flex: 1 1;
  }
}
.ChatModal_chatModal__wp__Xq-gj .modal {
  padding: 0;
}
.ChatModal_chatModal__wp__Xq-gj .modal__wrapper {
  align-items: initial;
  height: var(--app-height);
}
.ChatModal_chatModal__wp__Xq-gj .modal__body {
  padding: 0;
  height: auto;
}
.ChatModal_chatModal__wp__Xq-gj .modal__content {
  max-width: initial;
  border-radius: 0;
  height: 100%;
  padding: 0;
}
.ChatModal_chatModal__head__qpPJk {
  display: flex;
  align-items: center;
  height: 68px;
  border-bottom: 1px solid #EFF3F5;
  padding-left: 16px;
  padding-right: 10px;
  flex-shrink: 0;
}
@media (min-width: 640px) {
  .ChatModal_chatModal__head__qpPJk {
    height: 100px;
  }
}
.ChatModal_chatModal__main__v1BWS {
  height: 100%;
  background-color: #FBFBFB;
  position: relative;
  overflow-y: auto;
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.ChatModal_chatModal__mainBack__D4XlJ {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: center no-repeat;
  background-size: cover;
}
.ChatModal_chatModal__mainList__Ethq2 {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 12px 0;
}
.ChatModal_chatModal__mainListWp__LYE8I {
  padding-top: 10px;
  padding-bottom: 8px;
  padding-left: 16px;
  padding-right: 16px;
  min-height: 100%;
  line-height: 0;
  position: relative;
  overflow-x: hidden;
}
.ChatModal_chatModal__bottom__6Il-E {
  width: 100%;
  padding: 8px;
  background: #fff;
  border-top: 1px solid #E0E7EB;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: auto;
  flex-shrink: 0;
}
@media (min-width: 1200px) {
  .ChatModal_chatModal__bottom__6Il-E {
    justify-content: flex-start;
    align-items: center;
    background: none;
    min-height: var(--modal-footer-height);
    padding: 8px;
  }
}
.ChatModal_chatModal__input__\\+7\\+qU {
  color: var(--text-color);
  font-size: 14px;
  line-height: 18px;
  resize: none;
  background: transparent;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.ChatModal_chatModal__inputWp__Om6x7 {
  border-radius: 20px;
  width: calc(100% - 88px);
  background: #F9FAFB;
  padding: 11px 12px;
}
@media (min-width: 1200px) {
  .ChatModal_chatModal__inputWp__Om6x7 {
    width: auto;
    flex: 1 1;
    background: none;
    padding: 5px 4px 3px;
  }
}
.ChatModal_chatModal__append__6h8dQ {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ChatModal_chatModal__append__6h8dQ .fileDropzone {
  width: 0;
  height: 0;
  padding: 0;
  border: none;
  opacity: 0;
  visibility: hidden;
}
.ChatModal_chatModal__submit__WDanV {
  background: #4084F8;
  border: 1px solid #387BF4;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  color: var(--white);
  transition: var(--transition);
}
@media (min-width: 1200px) {
  .ChatModal_chatModal__submit__WDanV {
    width: 24px;
    height: 24px;
    color: var(--accent-color);
    background: none;
    border: none;
  }
}
@media (hover: hover) {
  .ChatModal_chatModal__submit__WDanV:hover {
    opacity: 0.7;
  }
}
.ChatModal_chatModal__chatDate__nf3rU {
  background: #E0E7EB;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  border-radius: 28px;
  padding: 4px 12px;
  color: #141B1F;
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
}
.ChatModal_chatModal__newMessage__cc8bu {
  display: flex;
  justify-content: center;
  overflow: hidden;
}
.ChatModal_chatModal__newMessage__cc8bu span {
  font-size: 12px;
  line-height: 13px;
  font-weight: 400;
  position: relative;
  color: #141B1F;
}
.ChatModal_chatModal__newMessage__cc8bu span::before, .ChatModal_chatModal__newMessage__cc8bu span::after {
  content: "";
  position: absolute;
  width: 50vw;
  height: 1px;
  background-color: #C2CFD6;
  top: 50%;
  transform: translateY(-50%);
  right: calc(100% + 8px);
}
.ChatModal_chatModal__newMessage__cc8bu span::after {
  right: auto;
  left: calc(100% + 8px);
}

.ChatModal_chatMessage__bsdro {
  display: flex;
  align-items: flex-end;
  max-width: 89%;
}
.ChatModal_chatMessage__avatar__-y1Do {
  width: 32px;
  height: 32px;
  margin-right: 4px;
  border-radius: 50%;
  background: #fff;
  overflow: hidden;
}
.ChatModal_chatMessage__avatar__-y1Do img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.ChatModal_chatMessage__block__p3KYo {
  padding: 8px;
  border-radius: 8px;
  background-color: #EFF3F5;
  max-width: 100%;
}
@media (min-width: 1200px) {
  .ChatModal_chatMessage__block__p3KYo {
    background-color: var(--white);
  }
}
.ChatModal_chatMessage__name__KSftI {
  color: #267339;
  margin-bottom: 2px;
  font-size: 14px;
  line-height: 16px;
  font-weight: 600;
}
@media (min-width: 1200px) {
  .ChatModal_chatMessage__name__KSftI {
    font-size: var(--fz-sm);
    line-height: 1;
  }
}
.ChatModal_chatMessage__text__3r4Gp {
  font-size: 17px;
  line-height: 22px;
  color: #141B1F;
  word-break: break-word;
  white-space: pre-wrap;
}
@media (min-width: 1200px) {
  .ChatModal_chatMessage__text__3r4Gp {
    font-size: var(--fz-md);
    line-height: var(--lh-lg);
  }
}
.ChatModal_chatMessage__text__3r4Gp a {
  color: var(--blue-300);
  text-decoration: underline;
  word-wrap: break-word;
  word-break: break-word;
}
.ChatModal_chatMessage__text__3r4Gp img {
  max-width: 100% !important;
  height: auto !important;
}
.ChatModal_chatMessage__time__h4v7v {
  margin-top: 2px;
  text-align: right;
  color: #6F7782;
  font-size: 12px;
  line-height: 12px;
  font-weight: 600;
}
@media (min-width: 1200px) {
  .ChatModal_chatMessage__time__h4v7v {
    color: #54575C;
    font-size: 10px;
    line-height: 11px;
  }
}
.ChatModal_chatMessage__images__fBDGA {
  display: flex;
  flex-direction: column;
  gap: 4px 0;
}
.ChatModal_chatMessage__images__fBDGA img {
  display: block;
  margin-top: 2px;
  max-width: 100%;
  border-radius: 8px;
  max-height: 350px;
  cursor: pointer;
  object-fit: cover;
}
.ChatModal_chatMessage__files__vwRIV > a {
  margin-top: 3px;
}
.ChatModal_chatMessage_my__sVhFJ {
  margin-left: auto;
}
.ChatModal_chatMessage_my__sVhFJ .ChatModal_chatMessage__block__p3KYo {
  background-color: #E3FFCA;
}
@media (min-width: 1200px) {
  .ChatModal_chatMessage_my__sVhFJ .ChatModal_chatMessage__block__p3KYo {
    background-color: #E3FFCA;
  }
}
.ChatModal_chatMessage_my__sVhFJ .ChatModal_chatMessage__time__h4v7v {
  color: #267339;
}
@media (min-width: 1200px) {
  .ChatModal_chatMessage_my__sVhFJ .ChatModal_chatMessage__time__h4v7v {
    color: #54575C;
  }
}
.ChatModal_chatMessage__gallery__2ab8I {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  visibility: hidden;
  opacity: 0;
  transition: 0.2s;
  z-index: 1002;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ChatModal_chatMessage__gallery_open__XKJsd {
  visibility: visible;
  opacity: 1;
}

.ChatModal_chatUpload__photos__-kFfw {
  display: flex;
  flex-wrap: wrap;
  margin-right: -6px;
  margin-bottom: -6px;
  padding-bottom: 6px;
}
.ChatModal_chatUpload__photo__I-0Te {
  flex: 0 0 76px;
  height: 54px;
  margin: 0 6px 6px 0;
  display: flex;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 2px;
}
.ChatModal_chatUpload__photo--solo__4lBdg {
  flex: 1 1;
  max-width: 100%;
}
.ChatModal_chatUpload__photo__I-0Te img {
  width: 100%;
  height: 100%;
  flex: 0 0 100%;
  object-fit: cover;
  position: relative;
  z-index: 2;
}
.ChatModal_chatUpload__photo__I-0Te:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 1;
}
.ChatModal_chatUpload__photoProgress__LCTtv {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;
}
.ChatModal_chatUpload__photoProgress__LCTtv + .ChatModal_chatUpload__removeImage__yX23z {
  opacity: 0;
}
.ChatModal_chatUpload__photoProgress__LCTtv span {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px;
  font-weight: 600;
  line-height: 14px;
  color: white;
}
.ChatModal_chatUpload__removeImage__yX23z {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  cursor: pointer;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.24);
  transition: 0.2s;
  color: #fff;
}
.ChatModal_chatUpload__removeImage__yX23z:hover {
  background: var(--color-focused);
}
.ChatModal_chatUpload__removeImage__yX23z i {
  color: white;
  margin: 0;
  font-size: 14px;
}
.ChatModal_chatUpload__attachments__0uvSF {
  padding-bottom: 6px;
  margin-top: 2px;
}

.ChatModal_emptyTxt__JBk8L {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--white);
  font-size: var(--fz-md);
  line-height: var(--lh-md);
  text-align: center;
  max-width: 300px;
  width: 100%;
  padding: 16px;
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/OrderModal/OrderModal.module.scss","webpack://./src/components/Modals/ChatModal/ChatModal.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;ACCF;ADEI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;ACAN;ADEM;EACE,kBAAA;EACA,YAAA;ACAR;ADGM;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;ACDR;ADGQ;EACE,gBAAA;ACDV;ADMI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ACJN;ADMM;EALF;IAMI,SAAA;ECHN;AACF;ADOM;EACE,iBAAA;EACA,YAAA;ACLR;ADUE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;ACRJ;ADWE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;ACTJ;ADUI;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;ACRN;ADUI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;ACRN;ADYE;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;ACVJ;ADaM;EACE,YAAA;ACXR;ADaU;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;ACXZ;ADaY;EACE,mBAAA;EACA,UAAA;ACXd;ADgBQ;EACE,WAAA;ACdV;ADeU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;ACbZ;ADoBE;EACE,4BAAA;AClBJ;ADqBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,4BAAA;EACA,eAAA;ACnBJ;ADqBI;EACE,YAAA;ACnBN;ADsBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;ACpBJ;ADsBI;EANF;IAOI,mBAAA;ECnBJ;AACF;ADsBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;ACpBJ;ADsBI;EANF;IAOI,eAAA;ECnBJ;AACF;ADqBI;EAVF;IAWI,uBAAA;IACA,yBAAA;EClBJ;AACF;ADoBI;EACE,0BAAA;AClBN;ADsBE;EACE,cAAA;ACpBJ;ADuBE;EACE,aAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;ACrBJ;ADwBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;ACtBJ;ADuBI;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;ACrBN;ADuBI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;ACrBN;ADyBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;ACvBJ;AD0BE;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;ACxBJ;AD2BE;EAEE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AC1BJ;AD2BI;EACE,YAAA;ACzBN;AD6BE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AC3BJ;AD8BE;EACE,WAAA;EACA,kBAAA;AC5BJ;AD8BI;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,oBAAA;AC5BN;AD8BM;EAPF;IAQI,WAAA;IACA,WAAA;IACA,YAAA;EC3BN;AACF;AD6BM;EAbF;IAcI,WAAA;IACA,YAAA;IACA,WAAA;EC1BN;AACF;AD6BI;;EAEE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,wBAAA;AC3BN;AD8BI;;;;EAIE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,wBAAA;AC5BN;AD+BK;EACC,wBAAA;EACA,6BAAA;AC7BN;ADiCI;;EAEE,0BAAA;EACA,cAAA;EACA,WAAA;AC/BN;ADmCI;;EAEE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;ACjCN;ADsCI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;ACpCN;ADsCM;EAbF;IAcI,YAAA;IACA,kBAAA;IACA,eAAA;ECnCN;AACF;ADqCM;EAnBF;IAoBI,YAAA;IACA,kBAAA;IACA,uBAAA;IACA,mBAAA;EClCN;AACF;ADoCM;EACE,cAAA;AClCR;ADuCM;EACE,WAAA;ACrCR;AD0CE;EAIE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AC3CJ;AD8CE;EACE,UAAA;EACA,gBAAA;AC5CJ;AD+CE;EACE,UAAA;EACA,gBAAA;AC7CJ;ADgDE;EACE,UAAA;EACA,gBAAA;EACA,kBAAA;AC9CJ;ADiDE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gCAAA;AC/CJ;ADgDI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AC9CN;ADiDI;EACE,kBAAA;EACA,YAAA;EACA,wBAAA;AC/CN;ADmDE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;ACjDJ;ADoDE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AClDJ;ADqDE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;ACnDJ;ADqDI;EACE,0BAAA;EACA,0BAAA;ACnDN;ADqDI;EACE,SAAA;EACA,UAAA;EACA,kBAAA;ACnDN;ADsDI;EACE,eAAA;ACpDN;ADsDI;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;ACpDN;ADuDI;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;ACrDN;ADwDI;EACE,gBAAA;ACtDN;ADyDI;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;ACvDN;AD0DI;EACE,gBAAA;ACxDN;AD2DI;EAGE,cAAA;AC3DN;AD6DI;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;AC3DN;AD6DI;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;AC3DN;AD+DE;EACE,gBAAA;AC7DJ;ADiEQ;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;AC/DV;ADiEU;EACE,WAAA;EACA,YAAA;AC/DZ;ADsEE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,6BAAA;ACpEJ;ADsEI;EACE;IACE,iCAAA;ECpEN;AACF;ADwEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,6BAAA;ACtEJ;ADwEI;EACE,eAAA;EACA,eAAA;ACtEN;AD2EI;EACE,WAAA;EACA,mBAAA;ACzEN;AD6EE;EACE,uBAAA;EACA,yBAAA;AC3EJ;AD8EE;EACE,uBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AC5EJ;AD+EE;EACE,iBAAA;EACA,mBAAA;AC7EJ;ADgFE;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AC9EJ;ADgFE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AC9EJ;ADiFI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AC/EN;ADkFI;EACE,eAAA;EACA,cAAA;EACA,oBAAA;AChFN;ADoFE;EACE,iBAAA;AClFJ;ADqFE;EAKQ;IACE,YAAA;ECvFV;EDwFU;IACE,WAAA;IACA,YAAA;IACA,cAAA;IACA,mBAAA;IACA,YAAA;ECtFZ;EDwFY;IACE,mBAAA;IACA,UAAA;ECtFd;ED8FE;IACE,oBAAA;EC5FJ;ED+FE;IACE,aAAA;IACA,kBAAA;EC7FJ;EDiGI;IACE,eAAA;EC/FN;EDkGI;IACE,eAAA;IACA,uBAAA;EChGN;EDoGE;IACE,gBAAA;EClGJ;EDqGE;IACE,mBAAA;IACA,YAAA;IACA,gBAAA;IACA,YAAA;IACA,kBAAA;ECnGJ;EDsGE;IACE,WAAA;IACA,YAAA;IACA,cAAA;IACA,eAAA;ECpGJ;EDuGE;IAEE,WAAA;IACA,YAAA;ECtGJ;EDuGI;IACE,WAAA;IACA,YAAA;ECrGN;AACF;ADwGE;EACE,qBAAA;ACtGJ;ADyGE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;ACvGJ;;AD2GA;EACE,aAAA;EACA,aAAA;EACA,qCAAA;EACA,kBAAA;ACxGF;AD0GE;EANF;IAOI,qCAAA;ECvGF;AACF;ADyGE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,8CAAA;ACvGJ;ADyGI;EACE,yBAAA;ACvGN;AD2GE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,+BAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACzGJ;AD4GE;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AC1GJ;AD4GI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AC1GN;AD8GE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,mBAAA;AC5GJ;ADiHI;EAFF;IAGI,aAAA;EC9GJ;AACF;ADgHI;EANF;IAOI,aAAA;EC7GJ;AACF;ADgHE;EACE,0CAAA;AC9GJ;ADiHE;EACE,4BAAA;EACA,sCAAA;AC/GJ;ADkHE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AChHJ;ADkHI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AChHN;ADmHI;EACE,kBAAA;EACA,6CAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;ACjHN;ADqHE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;ACnHJ;ADqHI;EACE,WAAA;EACA,UAAA;EACA,qCAAA;EACA,wBAAA;EACA,mCAAA;EACA,iCAAA;ACnHN;ADqHM;EACE,aAAA;ACnHR;ADwHE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,0CAAA;EACA,UAAA;ACtHJ;ADyHI;EACE,WAAA;EACA,UAAA;EACA,qCAAA;EACA,wBAAA;EACA,mCAAA;EACA,iCAAA;ACvHN;ADyHM;EACE,aAAA;ACvHR;;AD6HA;EACE;IACE,QAAA;EC1HF;ED6HA;IACE,QAAA;EC3HF;ED8HA;IACE,QAAA;EC5HF;AACF;ADgIE;EADF;IAEI,2BAAA;IACA,yBAAA;IACA,eAAA;EC7HF;AACF;ADgII;EADF;IAEI,WAAA;IACA,gBAAA;IACA,uBAAA;IACA,yBAAA;IACA,gBAAA;IACA,iBAAA;EC7HJ;AACF;;ADsIU;EADF;IAEI,cAAA;EClIV;AACF;;ADyIA;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;ACtIF;;ADyIA;EACE,aAAA;EACA,sBAAA;ACtIF;ADwIE;EAJF;IAKI,SAAA;ECrIF;AACF;;ADwIA;EACE,kBAAA;ACrIF;ADuIE;EACE,kBAAA;EACA,2BAAA;EACA,SAAA;ACrIJ;ADuII;EALF;IAMI,kBAAA;IACA,SAAA;IACA,OAAA;IACA,2BAAA;IACA,SAAA;ECpIJ;AACF;;ADwIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;ACrIF;ADuIE;EACE,iBAAA;ACrIJ;ADwIE;EACE,WAAA;EACA,YAAA;ACtIJ;ADwII;EACE,aAAA;ACtIN;;AD2IA;EACE,kBAAA;ACxIF;AD0IE;EACE,gBAAA;ACxIJ;AD2IE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;ACzIJ;;AAr0BA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAw0BJ;AAv0BI;EAJJ;IAKM,iBAAA;IACA,YAAA;IACA,SAAA;EA00BJ;AACF;AAt0BY;EACI,UAAA;AAw0BhB;AAt0BgB;EACI,oBAAA;EACA,yBAAA;AAw0BpB;AAr0BgB;EACI,UAAA;EACA,YAAA;AAu0BpB;AAp0BgB;EACI,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;AAs0BpB;AAh0BI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAk0BR;AAh0BQ;EATJ;IAUQ,aAAA;EAm0BV;AACF;AAh0BI;EACI,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EAGA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;AAg0BR;AA7zBI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,4BAAA;EACA,sBAAA;AA+zBR;AA5zBI;EACI,kBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;AA8zBR;AA5zBI;EACI,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AA8zBR;AA3zBI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;AA6zBR;AA3zBQ;EAXJ;IAYQ,2BAAA;IACA,mBAAA;IACA,gBAAA;IACA,sCAAA;IACA,YAAA;EA8zBV;AACF;AA3zBI;EACI,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;AA6zBR;AA1zBI;EACI,mBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;AA4zBR;AA1zBQ;EANJ;IAOQ,WAAA;IACA,SAAA;IACA,gBAAA;IACA,oBAAA;EA6zBV;AACF;AA1zBI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA4zBR;AAzzBY;EACI,QAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AA2zBhB;AAtzBI;EACI,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;AAwzBR;AAtzBQ;EAZJ;IAaQ,WAAA;IACA,YAAA;IACA,0BAAA;IACA,gBAAA;IACA,YAAA;EAyzBV;AACF;AAvzBQ;EACE;IACI,YAAA;EAyzBZ;AACF;AArzBI;EACI,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAuzBR;AApzBI;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;AAszBR;AArzBQ;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAuzBZ;AAtzBY;EAEI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,QAAA;EACA,2BAAA;EACA,uBAAA;AAuzBhB;AApzBY;EACI,WAAA;EACA,sBAAA;AAszBhB;;AAhzBA;EACI,aAAA;EACA,qBAAA;EACA,cAAA;AAmzBJ;AAjzBI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAmzBR;AAjzBQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAmzBZ;AA/yBI;EACI,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AAizBR;AA/yBQ;EANJ;IAOQ,8BAAA;EAkzBV;AACF;AA/yBI;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAizBR;AA/yBQ;EAPJ;IAQQ,uBAAA;IACA,cAAA;EAkzBV;AACF;AA/yBI;EACI,eAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,qBAAA;AAizBR;AA/yBQ;EAPJ;IAQQ,uBAAA;IACA,yBAAA;EAkzBV;AACF;AAhzBQ;EACI,sBAAA;EACA,0BAAA;EACA,qBAAA;EACA,sBAAA;AAkzBZ;AA/yBQ;EACI,0BAAA;EACA,uBAAA;AAizBZ;AA7yBI;EACI,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AA+yBR;AA7yBQ;EARJ;IASQ,cAAA;IACA,eAAA;IACA,iBAAA;EAgzBV;AACF;AA7yBI;EACI,aAAA;EACA,sBAAA;EACA,UAAA;AA+yBR;AA9yBQ;EACI,cAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AAgzBZ;AA3yBQ;EACI,eAAA;AA6yBZ;AAzyBI;EACI,iBAAA;AA2yBR;AAxyBY;EACI,yBAAA;AA0yBhB;AAxyBgB;EAHJ;IAIQ,yBAAA;EA2yBlB;AACF;AAzyBY;EACI,cAAA;AA2yBhB;AAzyBgB;EAHJ;IAIQ,cAAA;EA4yBlB;AACF;AAvyBI;EACI,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAyyBR;AAvyBQ;EACI,mBAAA;EACA,UAAA;AAyyBZ;;AAlyBI;EACI,aAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AAqyBR;AAlyBI;EACI,cAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAoyBR;AAjyBQ;EACI,SAAA;EACA,eAAA;AAmyBZ;AAhyBQ;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AAkyBZ;AA/xBQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;AAiyBZ;AA7xBI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;AA+xBR;AA7xBQ;EACI,UAAA;AA+xBZ;AA5xBQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AA8xBZ;AA1xBQ;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,gBAAA;EACA,WAAA;AA4xBR;AA1xBQ;EACI,gCAAA;AA4xBZ;AAzxBQ;EACI,YAAA;EACA,SAAA;EACA,eAAA;AA2xBZ;AAvxBI;EACI,mBAAA;EACA,eAAA;AAyxBR;;AArxBA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,8BAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AAwxBJ","sourcesContent":[".orderModal {\n  padding: 0;\n\n  :global {\n    .modal__inner {\n      height: 100%;\n      border-radius: 0;\n      max-width: none;\n      display: flex;\n      flex-direction: column;\n      height: 100%;\n\n      .modal__header {\n        padding: 24px 16px;\n        border: none;\n      }\n\n      .modal__body {\n        background: #FFF;\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n        overflow: auto;\n        padding: 0;\n\n        .submitBlock {\n          margin-top: auto;\n        }\n      }\n    }\n\n    .options-list {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n\n      @media (max-width: 1200px) {\n        gap: 24px;\n      }\n    }\n\n    .checkbox-row, .radio-row {\n      p {\n        line-height: 114%;\n        border: none;\n      }\n    }\n  }\n\n  .modal-text {\n    font-size: 14px;\n    line-height: 20px;\n    color: #54575C;\n  }\n\n  &__swipeHandler {\n    position: absolute;\n    top: -10px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    height: 2px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2;\n    span {\n      border-radius: 8px;\n      background: #FFF;\n      width: 88px;\n      height: 2px;\n      z-index: 2;\n      display: block;\n      position: relative;\n    }\n    &::before {\n      content: \"\";\n      position: absolute;\n      bottom: -5vh;\n      left: 0;\n      right: 0;\n      width: 100%;\n      height: 30vh;\n      background: transparent;\n    }\n  }\n\n  &__top {\n    width: 100%;\n    min-height: 216px;\n    height: 55vw;\n    max-height: 420px;\n    border-radius: 16px 16px 0 0;\n    overflow: hidden;\n\n    :global {\n      .swiper {\n        height: 100%;\n        &-pagination {\n          &-bullet {\n            width: 6px;\n            height: 6px;\n            margin: 0 6px;\n            background: #D9D9D9;\n            opacity: 0.4;\n\n            &-active {\n              background: #FAFAFA;\n              opacity: 1;\n            }\n          }\n        }\n\n        &-slide {\n          width: 100%;\n          img {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n            object-position: center;\n          }\n        }\n      }\n    }\n  }\n\n  &__roundedTop {\n    border-radius: 16px 16px 0 0;\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    border-radius: 16px 16px 0 0;\n    padding: 0 16px;\n\n    &_load {\n      gap: initial;\n    }\n  }\n  &__block {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin-bottom: 5px;\n\n    @media (min-width: 1200px) {\n      margin-bottom: 24px;\n    }\n  }\n\n  &__blockTitle {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 114%;\n    padding-bottom: 4px;\n\n    @media (min-width: 640px) {\n      font-size: 22px;\n    }\n\n    @media (min-width: 1200px) {\n      font-size: var(--fz-lg);\n      line-height: var(--lh-lg);\n    }\n\n    &::first-letter {\n      text-transform: capitalize;\n    }\n  }\n\n  &__blockRequired {\n    color: #f2200d;\n  }\n\n  &__submitBlock {\n    padding: 16px;\n    bottom: 0;\n    left: 50%;\n    background: #FFF;\n    z-index: 2;\n    position: sticky;\n    width: 100%;\n  }\n\n  &__submitBlockHead {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    h5 {\n      color: #151B26;\n      line-height: 114%;\n      font-size: 14px;\n      font-weight: 600;\n    }\n    p {\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 114%;\n      letter-spacing: -0.24px;\n    }\n  }\n\n  &__submitBlockBottom {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 12px;\n  }\n\n  &__calc {\n    height: 44px;\n    width: 88px;\n    min-width: 88px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 12px;\n    background: #EEE;\n    margin-right: 12px;\n  }\n\n  &__calcPlus,\n  &__calcMinus {\n    width: 16px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    &:disabled {\n      opacity: 0.5;\n    }\n  }\n\n  &__calcNum {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 20px;\n    color: #000;\n    width: 32px;\n    margin: 0 4px;\n    text-align: center;\n  }\n\n  &__picker {\n    width: 100%;\n    position: relative;\n\n    img {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      right: 10px;\n      pointer-events: none;\n\n      @media (min-width: 640px) {\n        right: 20px;\n        width: 32px;\n        height: 32px;\n      }\n\n      @media (min-width: 1200px) {\n        width: 22px;\n        height: 22px;\n        right: 10px;\n      }\n    }\n\n    input[type=\"date\"]:not(.has_value)::-webkit-datetime-edit-fields-wrapper,\n    input[type=\"datetime-local\"]:not(.has_value)::-webkit-datetime-edit-fields-wrapper {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      opacity: 0;\n      -webkit-appearance: none;\n    }\n\n    input[type=\"date\"]::-webkit-inner-spin-button,\n    input[type=\"datetime-local\"]::-webkit-inner-spin-button,\n    input[type=\"date\"]::-webkit-calendar-picker-indicator,\n    input[type=\"datetime-local\"]::-webkit-calendar-picker-indicator {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      opacity: 0;\n      -webkit-appearance: none;\n    }\n\n     input[type=\"date\"], input[type=\"datetime-local\"] {\n      -webkit-appearance: none;\n      width: -webkit-fill-available;\n     }\n\n    // Отображение placeholder у инпутов с типом даты\n    input[type=\"date\"]:not(.has_value):before, \n    input[type=\"datetime-local\"]:not(.has_value):before {\n      content: attr(placeholder);\n      color: #BEC0C2;\n      width: 100%;\n    }\n\n    // Блок для закрытия стрелки на мобилках\n    input[type=\"date\"]::after,\n    input[type=\"datetime-local\"]::after {\n      position: absolute;\n      right: 0;\n      content: \"\";\n      width: 20px;\n      height: 100%;\n      background: white;\n      border-radius: 8px;\n    }\n\n  \n\n    input {\n      width: 100%;\n      height: 40px;\n      border-radius: 8px;\n      border: 1px solid #E8ECEE;\n      background: #FFF;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 24px;\n      padding: 3px 10px;\n      position: relative;\n\n      @media (min-width: 640px) {\n        height: 64px;\n        padding-left: 32px;\n        font-size: 20px;\n      }\n\n      @media (min-width: 1200px) {\n        height: 38px;\n        padding-left: 10px;\n        font-size: var(--fz-md);\n        line-height: normal;\n      }\n\n      &::placeholder {\n        color: #BEC0C2;\n      }\n    }\n\n    :global {\n      .react-datepicker-wrapper {\n        width: 100%;\n      }\n    }\n  }\n\n  &__sk1,\n  &__sk2,\n  &__sk3,\n  &__sk4 {\n    border-radius: 2px;\n    height: 13px;\n    width: 100%;\n    margin-top: 8px;\n  }\n\n  &__sk2 {\n    width: 85%;\n    margin-top: 10px;\n  }\n\n  &__sk3 {\n    width: 50%;\n    margin-top: 10px;\n  }\n\n  &__sk4 {\n    width: 20%;\n    margin-top: 16px;\n    margin-bottom: 9px;\n  }\n\n  &__sk5 {\n    margin-top: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-left: 4px;\n    padding-top: 4px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #F3F2F2;\n    span {\n      width: 14px;\n      height: 14px;\n      border-radius: 50%;\n      display: block;\n      margin-top: 4px;\n      margin-bottom: 4px;\n    }\n\n    div {\n      border-radius: 2px;\n      height: 14px;\n      width: calc(100% - 34px);\n    }\n  }\n\n  &__info {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &__infoTitle {\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 144%;\n    color: var(--text-color);\n  }\n\n  &__infoText {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 144%;\n    word-wrap: break-word;\n\n    a {\n      color: var(--accent-color);\n      text-decoration: underline;\n    }\n    ul, ol{\n      margin: 0;\n      padding: 0;\n      padding-left: 16px;\n    }\n\n    img {\n      max-width: 100%;\n    }\n    table {\n      border-collapse: collapse;\n      table-layout: fixed;\n      width: 100%;\n      margin: 0;\n      overflow: hidden\n    }\n\n    table td,table th {\n      min-width: 1em;\n      border: 2px solid #ced4da;\n      padding: 3px 5px;\n      vertical-align: top;\n      box-sizing: border-box;\n      position: relative\n    }\n\n    table td>*,table th>* {\n      margin-bottom: 0\n    }\n\n    table th {\n      font-weight: 700;\n      text-align: left;\n      background-color: #f1f3f5\n    }\n\n    p {\n      min-height: 20px;\n    }\n\n    & h1,\n    & h2,\n    & h3 {\n      color: #303030;\n    }\n    pre {\n      background: #2b2a2a;\n      color: #fff;\n      padding: 8px;\n      display: flex;\n      border-radius: 8px;\n      width: 100%;\n      white-space: pre-wrap;\n    }\n    code {\n      width: 100%;\n      display: block;\n      color: #fff;\n      background-color: #f1f3f5;\n    }\n  }\n\n  &__files {\n    padding-top: 8px;\n\n    :global {\n      .orderModal {\n        &__file {\n          flex-direction: row;\n          flex-wrap: nowrap;\n          padding: 8px 32px 8px 4px;\n          border-radius: 12px;\n          border: 1px solid transparent;\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          position: relative;\n          transition: var(--transition);\n          margin-bottom: 8px;\n\n          img {\n            width: 15px;\n            height: 21px;\n          }\n        }\n      }\n    }\n  }\n\n  &__file {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    gap: 2px;\n    margin-bottom: 8px;\n    padding: 8px 32px 8px 4px;\n    background: var(--white);\n    border-radius: 12px;\n    border: 1px solid transparent;\n    position: relative;\n    transition: var(--transition);\n\n    @media (hover: hover) {\n      &:hover {\n        border-color: var(--accent-color);\n      }\n    }\n  }\n\n  &__fileContent {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    transition: var(--transition);\n\n    img {\n      max-width: 24px;\n      min-width: 24px;\n    }\n  }\n\n  &__fileIsLoading {\n    &__loader {\n      height: 3px;\n      background: #4084F8;\n    }\n  }\n\n  &__fileName {\n    font-size: var(--fz-md);\n    line-height: var(--lh-md);\n  }\n\n  &__fileSize {\n    font-size: var(--fz-sm);\n    line-height: 1;\n    color: #7A808B;\n    margin-top: 2px;\n  }\n\n  &__fileDelete {\n    margin-left: auto;\n    color: var(--error);\n  }\n\n  &__object {\n    border-radius: 12px;\n    background: #FAFAFA;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n  }\n  &__objectIco {\n    width: 26px;\n    min-width: 26px;\n    height: 26px;\n    margin-right: 8px;\n  }\n  &__objectText {\n    span {\n      font-size: 14px;\n      line-height: 114%;\n      color: #7A808B;\n    }\n\n    p {\n      font-size: 16px;\n      color: #101618;\n      line-height: 23.04px;\n    }\n  }\n\n  &__objectArrow {\n    margin-left: auto;\n  }\n\n  @media (min-width: 640px) {\n\n    &__top {\n      :global {\n        .swiper {\n          &-pagination {\n            bottom: 24px;\n            &-bullet {\n              width: 12px;\n              height: 12px;\n              margin: 0 12px;\n              background: #D9D9D9;\n              opacity: 0.4;\n    \n              &-active {\n                background: #FAFAFA;\n                opacity: 1;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    &__body {\n      padding: 16px 24px 0;\n    }\n\n    &__submitBlock {\n      padding: 24px;\n      margin-left: -24px;\n    }\n\n    &__submitBlockHead {\n      h5 {\n        font-size: 32px;\n      }\n\n      p {\n        font-size: 28px;\n        letter-spacing: -0.56px;\n      }\n    }\n\n    &__submitBlockBottom {\n      margin-top: 18px;\n    }\n\n    &__calc {\n      border-radius: 16px;\n      width: 195px;\n      min-width: 195px;\n      height: 76px;\n      margin-right: 16px;\n    }\n\n    &__calcNum {\n      width: 59px;\n      height: 22px;\n      margin: 0 16px;\n      font-size: 28px;\n    }\n\n    &__calcPlus,\n    &__calcMinus {\n      width: 32px;\n      height: 32px;\n      svg {\n        width: 32px;\n        height: 32px;\n      }\n    }\n  }\n  &__inputError.orderModal__inputError{\n    border-color: #F2200D;\n  }\n\n  &__time {\n    font-size: 12px;\n    padding: 2px 4px;\n    min-height: auto;\n  }\n}\n\n.photoBlock {\n  display: grid;\n  grid-gap: 8px;\n  grid-template-columns: repeat(3, 1fr);\n  position: relative;\n\n  @media (min-width: 1200px) {\n    grid-template-columns: repeat(6, 1fr);\n  }\n\n  &__append {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 8px;\n    height: 105px;\n    cursor: pointer;\n    background: rgba(var(--accent-color-rgb), 0.1);\n\n    &.error {\n      border: 1px solid #F2200D;\n    }\n  }\n\n  &__plus {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background: var(--accent-color);\n    color: var(--accent-text-color);\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &__preview {\n    height: 105px;\n    border-radius: 8px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n\n    &>img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n    }\n  }\n\n  &__close {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n    background: #E97676;\n  }\n\n  &__append,\n  &__preview {\n    @media (min-width: 640px) {\n      height: 140px;\n    }\n\n    @media (min-width: 1200px) {\n      height: 104px;\n    }\n  }\n\n  &__camera {\n    color: rgba(var(--accent-color-rgb), 0.45)\n  }\n\n  &__error {\n    position: initial !important;\n    justify-content: flex-start !important;\n  }\n\n  &__loader {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &__precent {\n      color: white;\n      font-weight: 600;\n      font-size: 12px;\n      z-index: 1;\n    }\n\n    &__overlay {\n      position: absolute;\n      background: #b2b2b2ad;\n      width: 100%;\n      height: 100%;\n      top: 0;\n    }\n  }\n\n  &__compressBlock {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    width: 60px;\n    height: 60px;\n    justify-content: space-between;\n    align-items: center;\n    z-index: 1;\n\n    svg {\n      width: 24px;\n      fill: none;\n      animation-name: grow;\n      animation-duration: 1.5s;\n      animation-iteration-count: infinite;\n      animation-timing-function: linear;\n\n      path {\n        stroke: white;\n      }\n    }\n  }\n\n  &__compressLoading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background-color: rgba(255,255,255, 0.8);\n    z-index: 3;\n\n\n    svg {\n      width: 24px;\n      fill: none;\n      animation-name: grow;\n      animation-duration: 1.5s;\n      animation-iteration-count: infinite;\n      animation-timing-function: linear;\n\n      path {\n        stroke: black;\n      }\n    }\n  }\n}\n\n@keyframes grow {\n  0% {\n    scale: (1);\n  }\n\n  50% {\n    scale: (2);\n  }\n\n  100% {\n    scale: (1);\n  }\n}\n\nlabel.checkboxAlone {\n  @media (min-width: 1200px) {\n    flex-direction: row-reverse;\n    justify-content: flex-end;\n    padding-left: 0;\n  }\n\n  p {\n    @media (min-width: 1200px) {\n      width: auto;\n      font-weight: 500;\n      font-size: var(--fz-lg);\n      line-height: var(--lh-lg);\n      padding-top: 5px;\n      margin-right: 8px;\n    }\n  }\n}\n\n.orderModal {\n  &__block {\n    .checkboxAlone {\n      p {\n        &:last-child {\n          @media (min-width: 1200px) {\n            margin-left: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n.conditionList {\n  position: initial;\n  overflow: hidden;\n  transition: 0.15s;\n}\n\n.conditionList__container {\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 1200px) {\n    gap: 24px;\n  }\n}\n\n.qrWrapBlock {\n  position: relative;\n\n  .qrWrapBlock__error {\n    position: relative;\n    justify-content: flex-start;\n    margin: 0;\n\n    @media (min-width: 1200px) {\n      position: absolute;\n      top: 100%;\n      left: 0;\n      justify-content: flex-start;\n      margin: 0;\n    }\n  }\n}\n\n.qrBlock {\n  padding: 10px;\n  border-radius: 8px;\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #EAF7EF;\n  width: max-content;\n  cursor: pointer;\n\n  &--error {\n    color: var(--red);\n  }\n\n  svg {\n    width: 13px;\n    height: 13px;\n\n    path {\n      fill: #2DBE64;\n    }\n  }\n}\n\n.QRInput {\n  position: relative;\n\n  input:disabled {\n    background: none;\n  }\n\n  &__icon {\n    position: absolute;\n    top: calc(50% - 16px);\n    right: 10px;\n    background: none;\n  }\n}","@import \"../OrderModal/OrderModal.module.scss\";\n.chatModal {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    @media (min-width: 1200px) {\n      min-height: 592px;\n      height: auto;\n      flex: 1;\n    }\n\n    &__wp {\n        :global {\n            .modal {\n                padding: 0;\n\n                &__wrapper {\n                    align-items: initial;\n                    height: var(--app-height);\n                }\n\n                &__body {\n                    padding: 0;\n                    height: auto;\n                }\n\n                &__content {\n                    max-width: initial;\n                    border-radius: 0;\n                    height: 100%;\n                    padding: 0;\n                }\n            }\n        }\n    }\n\n    &__head {\n        display: flex;\n        align-items: center;\n        height: 68px;\n        border-bottom: 1px solid #EFF3F5;\n        padding-left: 16px;\n        padding-right: 10px;\n        flex-shrink: 0;\n\n        @media (min-width: 640px) {\n            height: 100px;\n        }\n    }\n\n    &__main {\n        height: 100%;\n        background-color: #FBFBFB;\n        position: relative;\n        overflow-y: auto;\n        // overflow-x: hidden;\n        // height: calc(100% - 120px);\n        width: 100%;\n        background-image: url('../../../../public/img/chat_bg-2.png');\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: center;\n    }\n\n    &__mainBack {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: center no-repeat;\n        background-size: cover;\n    }\n\n    &__mainList {\n        position: relative;\n        z-index: 1;\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-end;\n        gap: 12px 0;\n    }\n    &__mainListWp {\n        padding-top: 10px;\n        padding-bottom: 8px;\n        padding-left: 16px;\n        padding-right: 16px;\n        min-height: 100%;\n        line-height: 0;\n        position: relative;\n        overflow-x: hidden;\n    }\n    \n    &__bottom {\n        width: 100%;\n        padding: 8px;\n        background: #fff;\n        border-top: 1px solid #E0E7EB;\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-end;\n        margin-top: auto;\n        flex-shrink: 0;\n\n        @media (min-width: 1200px) {\n            justify-content: flex-start;\n            align-items: center;\n            background: none;\n            min-height: var(--modal-footer-height);\n            padding: 8px;\n        }\n    }\n\n    &__input {\n        color: var(--text-color);\n        font-size: 14px;\n        line-height: 18px;\n        resize: none;\n        background: transparent;\n        width: 100%;\n        padding: 0;\n        overflow: hidden;\n    }\n\n    &__inputWp {\n        border-radius: 20px;\n        width: calc(100% - 88px);\n        background: #F9FAFB;\n        padding: 11px 12px;\n\n        @media (min-width: 1200px) {\n            width: auto;\n            flex: 1;\n            background: none;\n            padding: 5px 4px 3px;\n        }\n    }\n\n    &__append {\n        width: 40px;\n        height: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        :global {\n            .fileDropzone {\n                width: 0;\n                height: 0;\n                padding: 0;\n                border: none;\n                opacity: 0;\n                visibility: hidden;\n            }\n        }\n    }\n\n    &__submit {\n        background: #4084F8;\n        border: 1px solid #387BF4;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 50%;\n        width: 40px;\n        height: 40px;\n        color: var(--white);\n        transition: var(--transition);\n\n        @media (min-width: 1200px) {\n            width: 24px;\n            height: 24px;\n            color: var(--accent-color);\n            background: none;\n            border: none;\n        }\n\n        @media (hover: hover) {\n          &:hover {\n              opacity: 0.7;\n          }\n        }\n    }\n\n    &__chatDate {\n        background: #E0E7EB;\n        height: 20px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-left: auto;\n        margin-right: auto;\n        border-radius: 28px;\n        padding: 4px 12px;\n        color: #141B1F;\n        font-size: 12px;\n        line-height: 12px;\n        font-weight: 400;\n    }\n\n    &__newMessage {\n        display: flex;\n        justify-content: center;\n        overflow: hidden;\n        span {\n            font-size: 12px;\n            line-height: 13px;\n            font-weight: 400;\n            position: relative;\n            color: #141B1F;\n            &::before,\n            &::after {\n                content: \"\";\n                position: absolute;\n                width: 50vw;\n                height: 1px;\n                background-color: #C2CFD6;\n                top: 50%;\n                transform: translateY(-50%);\n                right: calc(100% + 8px);\n            }\n\n            &::after {\n                right: auto;\n                left: calc(100% + 8px);\n            }\n        }\n    }\n}\n\n.chatMessage {\n    display: flex;\n    align-items: flex-end;\n    max-width: 89%;\n\n    &__avatar {\n        width: 32px;\n        height: 32px;\n        margin-right: 4px;\n        border-radius: 50%;\n        background: #fff;\n        overflow: hidden;\n\n        img {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n        }\n    }\n\n    &__block {\n        padding: 8px;\n        border-radius: 8px;\n        background-color: #EFF3F5;\n        max-width: 100%;\n\n        @media (min-width: 1200px) {\n            background-color: var(--white);\n        }\n    }\n\n    &__name {\n        color: #267339;\n        margin-bottom: 2px;\n        font-size: 14px;\n        line-height: 16px;\n        font-weight: 600;\n\n        @media (min-width: 1200px) {\n            font-size: var(--fz-sm);\n            line-height: 1;\n        }\n    }\n\n    &__text {\n        font-size: 17px;\n        line-height: 22px;\n        color: #141B1F;\n        word-break: break-word;\n        white-space: pre-wrap;\n\n        @media (min-width: 1200px) {\n            font-size: var(--fz-md);\n            line-height: var(--lh-lg);\n        }\n\n        & a {\n            color: var(--blue-300);\n            text-decoration: underline;\n            word-wrap: break-word;\n            word-break: break-word;\n        }\n\n        img {\n            max-width: 100% !important;\n            height: auto !important;\n        }\n    }\n\n    &__time {\n        margin-top: 2px;\n        text-align: right;\n        color: #6F7782;\n        font-size: 12px;\n        line-height: 12px;\n        font-weight: 600;\n\n        @media (min-width: 1200px) {\n            color: #54575C;\n            font-size: 10px;\n            line-height: 11px;\n        }\n    }\n\n    &__images {\n        display: flex;\n        flex-direction: column;\n        gap: 4px 0;\n        img {\n            display: block;\n            margin-top: 2px;\n            max-width: 100%;\n            border-radius: 8px;\n            max-height: 350px;\n            cursor: pointer;\n            object-fit: cover;\n        }\n    }\n\n    &__files {\n        &>a {\n            margin-top: 3px;\n        }\n    }\n\n    &_my {\n        margin-left: auto;\n\n        .chatMessage {\n            &__block {\n                background-color: #E3FFCA;\n\n                @media (min-width: 1200px) {\n                    background-color: #E3FFCA;\n                }\n            }\n            &__time {\n                color: #267339;\n\n                @media (min-width: 1200px) {\n                    color: #54575C;\n                }\n            }\n        }\n    }\n\n    &__gallery {\n        position: fixed;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        width: 100%;\n        height: 100%;\n        background: rgba(0, 0, 0, .7);\n        visibility: hidden;\n        opacity: 0;\n        transition: .2s;\n        z-index: 1002;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        &_open {\n            visibility: visible;\n            opacity: 1;\n        }\n    }\n}\n\n.chatUpload {\n\n    &__photos {\n        display: flex;\n        flex-wrap: wrap;\n        margin-right: -6px;\n        margin-bottom: -6px;\n        padding-bottom: 6px;\n    }\n\n    &__photo {\n        flex: 0 0 76px;\n        height: 54px;\n        margin: 0 6px 6px 0;\n        display: flex;\n        position: relative;\n        border-radius: 4px;\n        overflow: hidden;\n        margin-top: 2px;\n        // background: transparent url(\"/img/loading.svg\") center center no-repeat;\n\n        &--solo {\n            flex: 1 1;\n            max-width: 100%;\n        }\n\n        & img {\n            width: 100%;\n            height: 100%;\n            flex: 0 0 100%;\n            object-fit: cover;\n            position: relative;\n            z-index: 2;\n        }\n\n        &:after {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            background: transparent;\n            z-index: 1;\n        }\n    }\n\n    &__photoProgress {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background: rgba(0,0,0,.7);\n        z-index: 100;\n\n        & + .chatUpload__removeImage {\n            opacity: 0;\n        }\n\n        & span {\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%,-50%);\n            font-size: 10px;\n            font-weight: 600;\n            line-height: 14px;\n            color: white;\n        }\n        }\n\n        &__removeImage {\n        position: absolute;\n        z-index: 2;\n        top: 0;\n        right: 0;\n        cursor: pointer;\n        width: 16px;\n        height: 16px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background: rgba(0,0,0,.24);\n        transition: 0.2s;\n        color: #fff;\n\n        &:hover {\n            background: var(--color-focused);\n        }\n\n        & i {\n            color: white;\n            margin: 0;\n            font-size: 14px;\n        }\n    }\n\n    &__attachments {\n        padding-bottom: 6px;\n        margin-top: 2px;\n    }\n}\n\n.emptyTxt {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    background-color: var(--white);\n    font-size: var(--fz-md);\n    line-height: var(--lh-md);\n    text-align: center;\n    max-width: 300px;\n    width: 100%;\n    padding: 16px;\n    border-radius: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orderModal": `ChatModal_orderModal__pId3A`,
	"modal-text": `ChatModal_modal-text__jyvbF`,
	"orderModal__swipeHandler": `ChatModal_orderModal__swipeHandler__8LsJK`,
	"orderModal__top": `ChatModal_orderModal__top__ta3Dh`,
	"orderModal__roundedTop": `ChatModal_orderModal__roundedTop__FrR8-`,
	"orderModal__body": `ChatModal_orderModal__body__dSj-c`,
	"orderModal__body_load": `ChatModal_orderModal__body_load__Hh4aO`,
	"orderModal__block": `ChatModal_orderModal__block__1DxAu`,
	"orderModal__blockTitle": `ChatModal_orderModal__blockTitle__hSmnK`,
	"orderModal__blockRequired": `ChatModal_orderModal__blockRequired__cgpUt`,
	"orderModal__submitBlock": `ChatModal_orderModal__submitBlock__ko3z-`,
	"orderModal__submitBlockHead": `ChatModal_orderModal__submitBlockHead__uksyZ`,
	"orderModal__submitBlockBottom": `ChatModal_orderModal__submitBlockBottom__qIdme`,
	"orderModal__calc": `ChatModal_orderModal__calc__3mUFl`,
	"orderModal__calcPlus": `ChatModal_orderModal__calcPlus__Dsh-s`,
	"orderModal__calcMinus": `ChatModal_orderModal__calcMinus__0SVej`,
	"orderModal__calcNum": `ChatModal_orderModal__calcNum__uL3S0`,
	"orderModal__picker": `ChatModal_orderModal__picker__4DNTj`,
	"has_value": `ChatModal_has_value__PXqo6`,
	"orderModal__sk1": `ChatModal_orderModal__sk1__b74va`,
	"orderModal__sk2": `ChatModal_orderModal__sk2__4+6IS`,
	"orderModal__sk3": `ChatModal_orderModal__sk3__uf1RO`,
	"orderModal__sk4": `ChatModal_orderModal__sk4__9pkrI`,
	"orderModal__sk5": `ChatModal_orderModal__sk5__xCgCH`,
	"orderModal__info": `ChatModal_orderModal__info__8awKR`,
	"orderModal__infoTitle": `ChatModal_orderModal__infoTitle__4VJup`,
	"orderModal__infoText": `ChatModal_orderModal__infoText__wW1r4`,
	"orderModal__files": `ChatModal_orderModal__files__kV2-u`,
	"orderModal__file": `ChatModal_orderModal__file__F4sSo`,
	"orderModal__fileContent": `ChatModal_orderModal__fileContent__Rch1r`,
	"orderModal__fileIsLoading__loader": `ChatModal_orderModal__fileIsLoading__loader__xlhBq`,
	"orderModal__fileName": `ChatModal_orderModal__fileName__Jxq3t`,
	"orderModal__fileSize": `ChatModal_orderModal__fileSize__nYr3i`,
	"orderModal__fileDelete": `ChatModal_orderModal__fileDelete__mmMLM`,
	"orderModal__object": `ChatModal_orderModal__object__yuVLY`,
	"orderModal__objectIco": `ChatModal_orderModal__objectIco__rlFMb`,
	"orderModal__objectText": `ChatModal_orderModal__objectText__ti14o`,
	"orderModal__objectArrow": `ChatModal_orderModal__objectArrow__tIZXL`,
	"orderModal__inputError": `ChatModal_orderModal__inputError__lwhbf`,
	"orderModal__time": `ChatModal_orderModal__time__D18jW`,
	"photoBlock": `ChatModal_photoBlock__UIMQi`,
	"photoBlock__append": `ChatModal_photoBlock__append__X0dn4`,
	"error": `ChatModal_error__9L5Cw`,
	"photoBlock__plus": `ChatModal_photoBlock__plus__Ngv43`,
	"photoBlock__preview": `ChatModal_photoBlock__preview__Mp8hP`,
	"photoBlock__close": `ChatModal_photoBlock__close__thpvX`,
	"photoBlock__camera": `ChatModal_photoBlock__camera__LmdLE`,
	"photoBlock__error": `ChatModal_photoBlock__error__Ab6kz`,
	"photoBlock__loader": `ChatModal_photoBlock__loader__dVtik`,
	"photoBlock__loader__precent": `ChatModal_photoBlock__loader__precent__vx4PK`,
	"photoBlock__loader__overlay": `ChatModal_photoBlock__loader__overlay__ubJnN`,
	"photoBlock__compressBlock": `ChatModal_photoBlock__compressBlock__rsFAh`,
	"grow": `ChatModal_grow__t26Uv`,
	"photoBlock__compressLoading": `ChatModal_photoBlock__compressLoading__jg6fF`,
	"checkboxAlone": `ChatModal_checkboxAlone__EtFUE`,
	"conditionList": `ChatModal_conditionList__xJ4u0`,
	"conditionList__container": `ChatModal_conditionList__container__+EAkr`,
	"qrWrapBlock": `ChatModal_qrWrapBlock__kyfe-`,
	"qrWrapBlock__error": `ChatModal_qrWrapBlock__error__ljW9I`,
	"qrBlock": `ChatModal_qrBlock__gZAcm`,
	"qrBlock--error": `ChatModal_qrBlock--error__Bwfjz`,
	"QRInput": `ChatModal_QRInput__yA8iF`,
	"QRInput__icon": `ChatModal_QRInput__icon__823hK`,
	"chatModal": `ChatModal_chatModal__MCV4E`,
	"chatModal__wp": `ChatModal_chatModal__wp__Xq-gj`,
	"chatModal__head": `ChatModal_chatModal__head__qpPJk`,
	"chatModal__main": `ChatModal_chatModal__main__v1BWS`,
	"chatModal__mainBack": `ChatModal_chatModal__mainBack__D4XlJ`,
	"chatModal__mainList": `ChatModal_chatModal__mainList__Ethq2`,
	"chatModal__mainListWp": `ChatModal_chatModal__mainListWp__LYE8I`,
	"chatModal__bottom": `ChatModal_chatModal__bottom__6Il-E`,
	"chatModal__input": `ChatModal_chatModal__input__+7+qU`,
	"chatModal__inputWp": `ChatModal_chatModal__inputWp__Om6x7`,
	"chatModal__append": `ChatModal_chatModal__append__6h8dQ`,
	"chatModal__submit": `ChatModal_chatModal__submit__WDanV`,
	"chatModal__chatDate": `ChatModal_chatModal__chatDate__nf3rU`,
	"chatModal__newMessage": `ChatModal_chatModal__newMessage__cc8bu`,
	"chatMessage": `ChatModal_chatMessage__bsdro`,
	"chatMessage__avatar": `ChatModal_chatMessage__avatar__-y1Do`,
	"chatMessage__block": `ChatModal_chatMessage__block__p3KYo`,
	"chatMessage__name": `ChatModal_chatMessage__name__KSftI`,
	"chatMessage__text": `ChatModal_chatMessage__text__3r4Gp`,
	"chatMessage__time": `ChatModal_chatMessage__time__h4v7v`,
	"chatMessage__images": `ChatModal_chatMessage__images__fBDGA`,
	"chatMessage__files": `ChatModal_chatMessage__files__vwRIV`,
	"chatMessage_my": `ChatModal_chatMessage_my__sVhFJ`,
	"chatMessage__gallery": `ChatModal_chatMessage__gallery__2ab8I`,
	"chatMessage__gallery_open": `ChatModal_chatMessage__gallery_open__XKJsd`,
	"chatUpload__photos": `ChatModal_chatUpload__photos__-kFfw`,
	"chatUpload__photo": `ChatModal_chatUpload__photo__I-0Te`,
	"chatUpload__photo--solo": `ChatModal_chatUpload__photo--solo__4lBdg`,
	"chatUpload__photoProgress": `ChatModal_chatUpload__photoProgress__LCTtv`,
	"chatUpload__removeImage": `ChatModal_chatUpload__removeImage__yX23z`,
	"chatUpload__attachments": `ChatModal_chatUpload__attachments__0uvSF`,
	"emptyTxt": `ChatModal_emptyTxt__JBk8L`
};
export default ___CSS_LOADER_EXPORT___;
